import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef, ViewChild, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AssetEventItemsResult, GridRequestQuery } from '@api/index';
import { map } from 'rxjs';
import { ComponentBaseDirective } from '../component.base';
@Component({
    selector: 'app-event-list',
    templateUrl: './event-list.component.html',
    styleUrls: ['./event-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class EventListComponent extends ComponentBaseDirective {
    private router = inject(Router);

    @Input() public events: AssetEventItemsResult;
    @Input() public eventListType: string;
    @Output() public gridRequestEvent = new EventEmitter<GridRequestQuery>();

    @ViewChild('eventSeverityTemplate', { static: true }) private eventSeverityTemplate: TemplateRef<string>;
    @ViewChild('startedTemplate', { static: true }) private startedTemplate: TemplateRef<string>;
    @ViewChild('endedTemplate', { static: true }) private endedTemplate: TemplateRef<string>;
    @ViewChild('eventListHeaderTemplate', { static: true }) private eventListHeaderTemplate: TemplateRef<string>;
    @ViewChild('eventListTemplate', { static: true }) private eventListTemplate: TemplateRef<string>;

    public columns$ = this.translationService.afterLanguageChanged$.pipe(
        map(() => {
            const columns = [
                { $$id: 'eventSeverity', width: 40, maxWidth: 40, sortable: false, resizeable: false, cellTemplate: this.eventSeverityTemplate, canAutoResize: false },
                { name: this.translationService.translate('defaults.description'), prop: 'description' },
                { name: this.translationService.translate('events.started'), prop: 'timestamp', cellTemplate: this.startedTemplate },
                { name: this.translationService.translate('events.ended'), prop: 'ceasedAt', cellTemplate: this.endedTemplate },
                { $$id: 'eventList', width: 180, maxWidth: 180, sortable: false, resizeable: false, headerTemplate: this.eventListHeaderTemplate, cellTemplate: this.eventListTemplate, canAutoResize: false },
            ];

            return columns;
        })
    );

    constructor() {
        super();
    }

    public navigateToEdgeDevice(deviceId: string) {
        this.router.navigate(['devices', deviceId]);
    }

    public navigateToAsset(edgeDeviceId: string, assetId: string) {
        this.router.navigate(['devices', edgeDeviceId, 'assets', assetId]);
    }

    public gridRequested(gridRequestQuery: GridRequestQuery) {
        this.gridRequestEvent.emit(gridRequestQuery);
    }
}
